import * as React from 'react'
import { memo } from 'react'
const SvgBrand = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 13.814 52"
  >
    <path d="M5.564 52V0h8.25v49.426H8.666V52Zm3.1-5.653h2.06V3.1H8.666ZM0 52V.013h3.092V52Z" />
  </svg>
)
const Memo = memo(SvgBrand)
export default Memo
